module.exports = __webpack_public_path__ + "static/media/vox-logo-dark.9b58fa4a.png";